// Request Cancellation Store
import {
  Computed as requestCancellationComputed,
  Methods as requestCancellationMethods,
} from '@/src/state/modules/request-cancellation-helpers'

// Authentication Store
import {
  Computed as authComputed,
  Methods as authMethods,
} from '@state/modules/auth-helpers'

// Filters Store
import {
  Computed as filtersComputed,
  Methods as filtersMethods,
} from '@/src/state/modules/filters-helpers'

// Info Store
import {
  Computed as infoComputed,
  Methods as infoMethods,
} from '@/src/state/modules/info-helpers'

// Info Details Store
import {
  Computed as infoDetailsComputed,
  Methods as infoDetailsMethods,
} from '@/src/state/modules/info-details-helpers'

// Device Store
import {
  Computed as deviceComputed,
  Methods as deviceMethods,
} from '@state/modules/device-helpers'

// Device Group Store
import {
  Computed as deviceGroupComputed,
  Methods as deviceGroupMethods,
} from '@state/modules/device-groups-helpers'

// Device Type Store
import {
  Computed as deviceTypeComputed,
  Methods as deviceTypeMethods,
} from '@state/modules/device-types-helpers'

// Device Activity Store
import {
  Computed as deviceActivityComputed,
  Methods as deviceActivityMethods,
} from '@/src/state/modules/device-activity-helpers'

// Device Cycle Store
import {
  Computed as deviceCycleComputed,
  Methods as deviceCycleMethods,
} from '@/src/state/modules/device-cycle-helpers'

// Device Condition Store
import {
  Computed as deviceConditionComputed,
  Methods as deviceConditionMethods,
} from '@/src/state/modules/device-condition-helpers'

// Device Shift Store
import {
  Computed as deviceShiftComputed,
  Methods as deviceShiftMethods,
} from '@/src/state/modules/device-shifts-helpers'

// Device Status Store
import {
  Computed as deviceStatusComputed,
  Methods as deviceStatusMethods,
} from '@/src/state/modules/device-status-helpers'

// Device Event Current Store
import {
  Computed as deviceEventCurrentComputed,
  Methods as deviceEventCurrentMethods,
} from '@/src/state/modules/device-event-current-helpers'

// Device Insight Store
import {
  Computed as deviceInsightsComputed,
  Methods as deviceInsightsMethods,
} from '@/src/state/modules/device-insights-helpers'

// Device Insight Data Store
import {
  Computed as deviceInsightsDataComputed,
  Methods as deviceInsightsDataMethods,
} from '@/src/state/modules/device-insights-data-helpers'

// Device productivity Store
import {
  Computed as deviceProductivityComputed,
  Methods as deviceProductivityMethods,
} from '@/src/state/modules/device-productivity-helpers'

// Actions Store
import {
  Computed as actionsComputed,
  Methods as actionsMethods,
} from '@/src/state/modules/actions-helpers'

// Configuration Store
import {
  Computed as configurationComputed,
  Methods as configurationMethods,
} from '@/src/state/modules/configuration-helpers'

// Entity Description Store
import {
  Computed as entityDescriptionComputed,
  Methods as entityDescriptionMethods,
} from '@/src/state/modules/entity-description-helpers'

// User Admin Store
import {
  Computed as usersAdminComputed,
  Methods as usersAdminMethods,
} from '@/src/state/modules/users-admin-helpers'

// User Edge Store
import {
  Computed as edgeComputed,
  Methods as edgeMethods,
} from '@/src/state/modules/edge-helpers'

export { authComputed, authMethods }
export { filtersComputed, filtersMethods }
export { infoComputed, infoMethods }
export { infoDetailsComputed, infoDetailsMethods }
export { deviceComputed, deviceMethods }
export { deviceGroupComputed, deviceGroupMethods }
export { deviceTypeComputed, deviceTypeMethods }
export { deviceActivityComputed, deviceActivityMethods }
export { deviceStatusComputed, deviceStatusMethods }
export { deviceShiftComputed, deviceShiftMethods }
export { deviceEventCurrentComputed, deviceEventCurrentMethods }
export { deviceInsightsComputed, deviceInsightsMethods }
export { deviceInsightsDataComputed, deviceInsightsDataMethods }
export { deviceCycleComputed, deviceCycleMethods }
export { deviceConditionComputed, deviceConditionMethods }
export { deviceProductivityComputed, deviceProductivityMethods }
export { actionsComputed, actionsMethods }
export { configurationComputed, configurationMethods }
export { entityDescriptionComputed, entityDescriptionMethods }
export { usersAdminComputed, usersAdminMethods }
export { requestCancellationMethods, requestCancellationComputed }
export { edgeComputed, edgeMethods }
